<div class="reel-root" [@fadeInOut]>
  <div class="reel-stage">
    <!-- Media layer: a 2-element video pool (active plays, the other prefetches the next clip) —
         both stay mounted so their ViewChild refs are stable across clips. -->
    <div class="reel-media" [class.reel-media-hidden]="screen !== 'reel'">
      <video
        #slot0
        class="reel-video"
        [class.reel-hide]="!isVideoClip || activeSlot !== 0"
        muted
        playsinline
        preload="auto"
        (playing)="onVideoPlaying(0)"
        (waiting)="onVideoWaiting(0)"
        (ended)="onVideoEnded(0)"
        (error)="onVideoError(0)"
      ></video>
      <video
        #slot1
        class="reel-video"
        [class.reel-hide]="!isVideoClip || activeSlot !== 1"
        muted
        playsinline
        preload="auto"
        (playing)="onVideoPlaying(1)"
        (waiting)="onVideoWaiting(1)"
        (ended)="onVideoEnded(1)"
        (error)="onVideoError(1)"
      ></video>

      <img
        *ngIf="showStill && stillUrl"
        class="reel-still"
        [src]="stillUrl"
        [style.objectFit]="stillObjectFit"
        alt=""
      />

      <div *ngIf="isBuffering && !showStill" class="reel-spinner"></div>
    </div>

    <!-- STORY chrome -->
    <ng-container *ngIf="screen === 'reel'">
      <div class="reel-scrim-top"></div>
      <div class="reel-scrim-bottom"></div>

      <!-- Full-bleed tap layer: tap-left/right to navigate, hold to pause. -->
      <div
        class="reel-tap"
        (pointerdown)="onPointerDown()"
        (pointerup)="onPointerUp($event)"
        (pointercancel)="onPointerCancel()"
      ></div>

      <!-- Progress segments (only for multi-clip reels). -->
      <div class="reel-progress" *ngIf="!isSingleClip">
        <button
          type="button"
          class="reel-seg"
          *ngFor="let seg of clips; let i = index; trackBy: trackByIndex"
          (click)="jumpTo(i)"
          [attr.aria-label]="'reel.upNext' | translate"
        >
          <span class="reel-seg-fill" [style.width.%]="segmentFill(i) * 100"></span>
        </button>
      </div>

      <!-- Close (X) — web parity affordance (a11y + desktop). -->
      <button type="button" class="reel-close" (click)="close()" [attr.aria-label]="'reel.close' | translate">
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" fill="none" />
        </svg>
      </button>

      <!-- Up-next pill (final 1.5s of a clip). -->
      <button type="button" class="reel-upnext" *ngIf="showUpNext" (click)="next()">
        <span class="reel-upnext-label">{{ 'reel.upNext' | translate | uppercase }}</span>
        <span class="reel-upnext-teaser" *ngIf="upNextTeaser">{{ upNextTeaser }}</span>
        <span class="reel-upnext-arrow" aria-hidden="true">→</span>
      </button>

      <!-- Bottom stack: caption (non-interactive) above the persistent panel. -->
      <div class="reel-bottom">
        <div class="reel-caption" *ngIf="captionTitle || captionSubtitle">
          <div class="reel-caption-title" *ngIf="captionTitle">{{ captionTitle }}</div>
          <div class="reel-caption-sub" *ngIf="captionSubtitle">{{ captionSubtitle }}</div>
        </div>

        <!-- The tap is analytics ONLY — nothing happens on screen. `.reel-panel` already sets
             pointer-events: auto inside the pointer-events: none `.reel-bottom` wrapper, so this
             needs no CSS and no stopPropagation: the tap layer binds pointerdown on `.reel-tap`,
             a sibling subtree, which this click never travels through. -->
        <app-reel-ask-panel
          class="reel-panel"
          (click)="onAskPanelTap()"
          [title]="panelTitle"
          [subtitle]="panelSubtitle"
          [imageUrl]="banner.panelImageUrl || null"
          [price]="banner.price || null"
        ></app-reel-ask-panel>
      </div>

      <!-- One-time coach overlay. -->
      <div class="reel-coach" *ngIf="showCoach" (click)="dismissCoach()">
        <div class="reel-coach-row">
          <div class="reel-coach-hint">
            <span class="reel-coach-emoji" aria-hidden="true">👈</span>
            <span>{{ 'reel.coachTapBack' | translate }}</span>
          </div>
          <div class="reel-coach-hint">
            <span class="reel-coach-emoji" aria-hidden="true">✊</span>
            <span>{{ 'reel.coachHoldPause' | translate }}</span>
          </div>
          <div class="reel-coach-hint">
            <span class="reel-coach-emoji" aria-hidden="true">👉</span>
            <span>{{ 'reel.coachTapNext' | translate }}</span>
          </div>
        </div>
      </div>
    </ng-container>

    <!-- END CARD -->
    <app-reel-end-card
      *ngIf="screen === 'end'"
      [heroUrl]="banner.detailsImageUrl || null"
      [logoUrl]="banner.brandLogoUrl || null"
      [title]="endTitle"
      [description]="endDescription"
      [watchAgainLabel]="watchAgainLabel"
      [closeLabel]="closeLabel"
      [backgroundType]="banner.backgroundType"
      [catalog]="catalog"
      (watchAgain)="watchAgain()"
      (close)="close()"
    ></app-reel-end-card>
  </div>
</div>
